// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/enterprise/performances/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const enterprisePerformancesEN: PageEntry = {
  id: "post.unternehmen-leistungen",
  locale: "en",
  slug: "enterprise/performances",
  seo: {
    navLabel: "Services",
    title: "Services provided by Dietz Federn",
    description: "Services provided by Dietz Federn",
  },
  type: "hub",
  h1: "Services provided by Dietz Federn",
  blocks: [
    { kind: "paragraph", text: "Our choice of materials is based on strict criteria, many years of experience and thorough market analyses. We work closely with renowned suppliers who provide us with a wide range of high-quality materials from all over the world." },
  ],
  cards: [
    { title: "Production", href: "/en/enterprise/performances/production/", body: "From mechanical components to electronic parts, we offer customised solutions for every customer. We utilise the latest technologies and production processes to ensure the highest quality standards.", thumb: "/images/live/dietz-produktionshalle.jpg" },
    { title: "Quality", href: "/en/enterprise/performances/quality/", body: "We are IATF 16949 certified and fulfil the highest quality standards. Our company relies on automation, process optimisation and continuous improvement to ensure that our customers always receive the best possible quality.", thumb: "/images/live/dietz-qualitaet-2.jpg" },
    { title: "Logistics", href: "/en/enterprise/performances/logistics/", body: "Dietz GmbH uses its comprehensive expertise to optimise processes in the supply chain in order to ensure efficient and smooth logistics.", thumb: "/images/live/dietz-logistik-2.jpg" },
    { title: "Material", href: "/en/enterprise/performances/material/", body: "Our company attaches great importance to a careful selection of materials in order to provide our customers with the best possible quality and performance.", thumb: "/images/services/material.jpg" },
  ],
};
